import { useEffect, useState } from 'react';
import APIS from '../../constant/EndPoint';
import { useGetHookE } from '../../customHooks/useGetHook';
import usePostHook from '../../customHooks/usePostHook';
import Spinner from '../Reusable/Spinner';

const DeliveryChargeTable = (props: any) => {
  const { localServiceBranch, localServiceType, merchantId, delivery_charge_template = null } = props
  const { data: deliveryChargeData, isLoading: DeliveryChargeLoading } = useGetHookE({
    queryKey: ["delivery-charge", `delivery-charge-${localServiceBranch}-${localServiceType}-${merchantId}`],
    url: APIS.DELIVERY_CHARGE,
    params: {
      branch: localServiceBranch,
      localServiceType: localServiceType,
      merchant: merchantId,
      delivery_charge_template:delivery_charge_template
    },
  });

  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: [`delivery-charge-${localServiceBranch}-${localServiceType}-${merchantId}`],
    navigateURL: "",
  });



  const handleDeliveryChargeChange = async (destination_city: string, product_type: string, amount: string) => {
    const url = `${APIS.DELIVERY_CHARGE}`;
    let formData = {
      delivery_charge_template: delivery_charge_template,
      pickup_branch: localServiceBranch,
      destination_city: destination_city,
      merchant: merchantId,
      service_type: localServiceType,
      product_type: product_type,
      amount: amount,
    };

    try {
      await mutateAsync({ url, formData });
    } catch (err) {
      console.log(err);
    }
  }

  const [rerender, setRerender] = useState(true);

  useEffect(() => {
    setRerender(!rerender)
  }, [deliveryChargeData])

  console.log("isLoading", DeliveryChargeLoading)

  return (
    <div className='w-full overflow-auto min-h-10'>
      {DeliveryChargeLoading ? <Spinner /> :
        <table>
          <thead className='text-justify'>
            <tr>
              <th className='pr-12 whitespace-nowrap'>Branch Name</th>
              {deliveryChargeData?.header?.map((item: any, index: number) => (
                <th key={`product-type-${index}`}>{item?.name}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {deliveryChargeData?.body?.map((productType: any, index: number) => (
              <tr key={`service-city${index}`}>
                <td>{productType?.name}</td>
                {productType?.rate?.map((item: any, index: number) => (
                  <td key={`rate-${index}`}><input type="text" onBlur={(event: any) => handleDeliveryChargeChange(productType?.location_id, deliveryChargeData?.header?.[index]?.id, event?.target?.value)} defaultValue={item} /></td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      }
    </div>

  )
}

export default DeliveryChargeTable